document.addEventListener('DOMContentLoaded', function () {
  const currency = window.Shopify?.currency?.active || 'EUR';
  const cartData = window.GTMData.value;
  function pushEventToDataLayer(type, data, quantityOverride) {
    const eventData = {
      event: type,
      ecommerce: {
        currency: currency,
        value: cartData,
        items: [
          {
            item_id: data.item_id,
            item_name: data.name,
            item_brand: data.brand,
            price: data.price,
            quantity:
              type === 'add_to_cart'
                ? 1
                : typeof quantityOverride === 'number'
                ? quantityOverride
                : data.quantity || 1,
            discount: data.discount,
          },
        ],
      },
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push(eventData);
    console.log(`[GA4] Evento ${type} inviato:`, eventData);
  }

  function getProductDataFromGTM(variantId) {
    if (!window.gtmdata || !window.gtmdata.cartItems) return null;
    return window.gtmdata.cartItems.find(
      (item) => String(item.variant_id) === String(variantId)
    );
  }

  function getProductDataFromContext(contextEl) {
    const input =
      contextEl.querySelector('.quantity__input') ||
      contextEl.querySelector('input[data-quantity-variant-id]');
    const variantId = input?.dataset.quantityVariantId || null;
    const quantity = input?.value ? parseInt(input.value, 10) : 1;

    if (!variantId) return {};
    const gtmItem = getProductDataFromGTM(variantId);
    if (gtmItem) {
      return {
        variantId: gtmItem.variant_id,
        price: gtmItem.price,
        item_id: gtmItem.item_id,
        discount: gtmItem.discount,
        name: gtmItem.item_name,
        brand: gtmItem.item_brand,
        category: gtmItem.category,
        quantity: quantity,
      };
    }

    const nameEl = contextEl.querySelector('.cart-item__name');
    const brandEl = contextEl.querySelector('.vendor-p');
    const sku = input?.dataset.sku || input?.getAttribute('data-sku') || null;
    const price = input?.dataset.price;
    let maxPriceRaw =
      input?.dataset.compareAtPrice ||
      input?.getAttribute('data-compare-at-price') ||
      price;
    let maxPrice = parseFloat(maxPriceRaw);
    if (isNaN(maxPrice) || maxPrice < price) maxPrice = price;
    const discount = Math.max(0, maxPrice - price);
    return {
      variantId: variantId,
      price: price,
      item_id: sku,
      discount: discount,
      name: nameEl?.textContent.trim() || 'Prodotto',
      brand: brandEl?.textContent.trim() || 'Brand',
      category: input?.dataset.category || 'Categoria',
      quantity: quantity,
    };
  }

  document.body.addEventListener('click', function (e) {
    const plusBtn = e.target.closest('button[name="plus"]');
    const minusBtn = e.target.closest('button[name="minus"]');
    const removeBtn = e.target.closest(
      'cart-remove-button a, a.button--tertiary[aria-label*="remove"], a.button--tertiary[aria-label*="Remove"]'
    );

    if (plusBtn) {
      const wrapper =
        plusBtn.closest('quantity-input') || plusBtn.closest('.cart-item');
      if (!wrapper) return;
      const data = getProductDataFromContext(wrapper);
      if (data.variantId) pushEventToDataLayer('add_to_cart', data);
      return;
    }

    if (minusBtn) {
      const wrapper =
        minusBtn.closest('quantity-input') || minusBtn.closest('.cart-item');
      if (!wrapper) return;
      const data = getProductDataFromContext(wrapper);
      if (data.variantId) pushEventToDataLayer('remove_from_cart', data, 1);
      return;
    }

    if (removeBtn) {
      const tr =
        removeBtn.closest('tr.cart-item') ||
        removeBtn.closest('.cart-item') ||
        document;
      const data = getProductDataFromContext(tr);
      // Prendi la quantità attuale dell'input
      let quantity = 1;
      const input = tr.querySelector('.quantity__input');
      if (input && input.value) {
        quantity = parseInt(input.value, 10) || 1;
      }
      if (data.variantId)
        pushEventToDataLayer('remove_from_cart', data, quantity);
      return;
    }
  });
});
